module.exports = __webpack_public_path__ + "static/media/research-process-1.887a64ad.png";